// extracted by mini-css-extract-plugin
export default {"List":"P2Cl27gubxmG4jUt2Vos","List__Item":"n8PoQktFsh6cgPxHENwu","List__Item__Name":"b5FQmPRVx_SC0t57LxyN","List__Item__Price":"ymXhclMwmH094ETQ7jFA"};